function removeColumns (resource, key, acc) {
  const value = resource.columns[key]
  // do not add cms related columns
  if (key.startsWith('permit_')) {
    return acc
  }

  // do not add columns that have a null value
  if (value === null) {
    return acc
  }

  if (key === 'file') {
    return {
      ...acc,
      [key]: {
        url: value.url,
        content_type: value.content_type,
        byte_size: value.byte_size
      }
    }
  }

  return {
    ...acc,
    [key]: value
  }
}

const columnReducer = (resources) => {
  const optimized = resources.map((resource) => {
    const columns = Object
      .keys(resource.columns)
      .reduce((acc, key) =>
        removeColumns(resource, key, acc), {}
      )

    return {
      ...resource,
      columns
    }
  })
  return optimized
}

export default columnReducer
